import {
  Close as CloseIcon,
  StarBorder as StarBorderIcon,
  Star as StarIcon,
} from "@mui/icons-material";
import {
  Box,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import {
  WorkItemList,
  WorkItemStateEnum,
  WorkItemTypeEnum,
} from "../../store/services/timelineApiRTK";
import { WorkItemFavoriteTypeEnum } from "../../store/services/workItemService";
import {
  getTeamColor,
  getWorkItemIcon,
  getWorkItemTypeName,
} from "../../utils/workItemUtils";

interface ActivityDialogHeaderProps {
  activity: WorkItemList;
  onClose: () => void;
  onToggleFavorite: () => void;
}

const ActivityDialogHeader: React.FC<ActivityDialogHeaderProps> = ({
  activity,
  onClose,
  onToggleFavorite,
}) => {
  const teamColor = getTeamColor(activity.Team?.Id);

  return (
    <DialogTitle
      sx={{
        background: `linear-gradient(135deg, ${teamColor} 0%, ${teamColor}dd 100%)`,
        color: "white",
        p: 0,
        position: "relative",
      }}
    >
      <Box sx={{ p: 3, pb: 2 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Box
              sx={{
                p: 1,
                borderRadius: 2,
                bgcolor: "rgba(255,255,255,0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {getWorkItemIcon(activity.Type || WorkItemTypeEnum.PhoneCall)}
            </Box>
            <Box>
              <Typography variant="h5" fontWeight="bold">
                {activity.Name || "Ny aktivitet"}
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                {getWorkItemTypeName(activity.Type || WorkItemTypeEnum.NotSet)}
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Tooltip
              title={
                activity?.FavoriteType === WorkItemFavoriteTypeEnum.Favorite
                  ? "Ta bort från favoriter"
                  : "Lägg till som favorit"
              }
            >
              <IconButton onClick={onToggleFavorite} sx={{ color: "white" }}>
                {activity?.FavoriteType ===
                WorkItemFavoriteTypeEnum.Favorite ? (
                  <StarIcon />
                ) : (
                  <StarBorderIcon />
                )}
              </IconButton>
            </Tooltip>

            <IconButton onClick={onClose} sx={{ color: "white" }}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
      </Box>

      {/* Status indicator */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          height: 4,
          bgcolor:
            activity.State === WorkItemStateEnum.Active
              ? "success.main"
              : "grey.400",
        }}
      />
    </DialogTitle>
  );
};

export default ActivityDialogHeader;
